import httpStore from "@/api/httpStore.js";

/**
 * Get all forms for the store
 */
export function getForms() {
  return httpStore
    .get(`/forms/set`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

/**
 * Get a single form by ID
 */
export function getForm(id) {
  return httpStore
    .get(`/forms/single/${id}`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

/**
 * Create a new form
 */
export function createForm(data) {
  return httpStore
    .post(`/forms/create`, {
      name: data.name,
      definition: data.definition,
      is_active: data.is_active || 1
    })
    .then(res => res.data.data || res.data)
    .catch(e => {
      throw e;
    });
}

/**
 * Update a form
 */
export function updateForm(id, data) {
  return httpStore
    .put(`/forms/single/${id}`, {
      name: data.name,
      definition: data.definition,
      is_active: data.is_active || 1
    })
    .then(res => res.data.data || res.data)
    .catch(e => {
      throw e;
    });
}

/**
 * Get a single submission by ID
 */
export function getSubmission(submissionId) {
  return httpStore
    .get(`/forms/submission/${submissionId}`, { skipCamelize: true })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

/**
 * Get all submissions from all forms
 */
export function getAllSubmissions() {
  return httpStore
    .get(`/forms/submissions`, { skipCamelize: true })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

/**
 * Get all submissions for a form
 */
export function getSubmissions(formId) {
  return httpStore
    .get(`/forms/submissions`, {
      skipCamelize: true,
      params: { form_id: formId }
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

/**
 * Delete a form
 */
export function deleteForm(id) {
  return httpStore
    .delete(`/forms/single/${id}`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

/**
 * Generate or update a form definition using Claude AI (server-to-server proxy)
 */
export function generateFormWithAI(prompt, currentForm = null, history = []) {
  return httpStore
    .post(`/ai/form_generate`, {
      prompt,
      current_form: currentForm,
      history
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

/**
 * Use Claude to map form responses to a customer profile
 * fields: [{label, value}]
 */
export function mapCustomerWithAI(fields) {
  return httpStore
    .post(`/ai/map_customer`, { fields })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

/**
 * Mark a submission as processed
 */
export function markSubmissionAsProcessed(submissionId) {
  return httpStore
    .put(`/forms/submission_process/${submissionId}`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}
